<div class="p-5">

  <h2 class="text-xl font-semibold mb-5">

    Tax Details

  </h2>

  <!-- ==================================== -->
  <!-- LINE TAXES -->
  <!-- ==================================== -->

  <div class="mb-8">

    <h3 class="font-semibold mb-3">

      Line Item Taxes

    </h3>

    <table
      class="table-auto w-full border">

      <thead>

        <tr class="bg-gray-100">

          <th class="p-2">
            Item
          </th>

          <th class="p-2">
            Qty
          </th>

          <th class="p-2">
            Price
          </th>

          <th class="p-2">
            Base
          </th>

          <th class="p-2">
            Tax
          </th>

          <th class="p-2">
            Total
          </th>

        </tr>

      </thead>

      <tbody>

        <ng-container
          *ngFor="let line of lines">

          <tr>

            <td class="p-2">

              {{
                line.item_name ||
                line.item_id?.label ||
                line.item_id
              }}

            </td>

            <td class="p-2 text-right">

              {{ line.quantity }}

            </td>

            <td class="p-2 text-right">

              {{ line.unit_price }}

            </td>

            <td class="p-2 text-right">

              {{ line.line_total }}

            </td>

            <td class="p-2 text-right">

              {{ line.tax_amount }}

            </td>

            <td class="p-2 text-right">

              {{
                (line.line_total || 0)
                +
                (line.tax_amount || 0)
              }}

            </td>

          </tr>

          <tr
            *ngFor="
              let tax of
              (line.tax_lines || [])
            ">

            <td colspan="3"
                class="pl-10">

              {{
                tax.taxName ||
                tax.tax_name
              }}

            </td>

            <td class="text-right">

              {{
                tax.taxableAmount ||
                tax.taxable_amount
              }}

            </td>

            <td class="text-right">

              {{
                tax.taxAmount ||
                tax.tax_amount
              }}

            </td>

            <td></td>

          </tr>

        </ng-container>

      </tbody>

    </table>

  </div>

  <!-- ==================================== -->
  <!-- TRANSACTION TAX -->
  <!-- ==================================== -->

  <div class="mb-8">

    <h3 class="font-semibold mb-3">

      Transaction Tax Summary

    </h3>

    <table
      class="table-auto w-full border">

      <thead>

        <tr class="bg-gray-100">

          <th class="p-2">
            Tax
          </th>

          <th class="p-2">
            Rate
          </th>

          <th class="p-2">
            Amount
          </th>

        </tr>

      </thead>

      <tbody>

        <tr
          *ngFor="
            let tax of
            transactionTaxSummary
          ">

          <td class="p-2">

            {{ tax.taxName }}

          </td>

          <td class="p-2 text-right">

            {{ tax.rate }}

          </td>

          <td class="p-2 text-right">

            {{ tax.amount }}

          </td>

        </tr>

      </tbody>

    </table>

  </div>

  <!-- ==================================== -->
  <!-- TOTALS -->
  <!-- ==================================== -->

  <div>

    <h3 class="font-semibold mb-3">

      Transaction Totals

    </h3>

    <table
      class="table-auto w-full border">

      <tbody>

        <tr>

          <td class="p-2">
            Subtotal
          </td>

          <td class="p-2 text-right">

            {{
              summary.subtotal
            }}

          </td>

        </tr>

        <tr>

          <td class="p-2">
            Tax
          </td>

          <td class="p-2 text-right">

            {{
              summary.taxTotal
            }}

          </td>

        </tr>

        <tr class="font-semibold">

          <td class="p-2">
            Grand Total
          </td>

          <td class="p-2 text-right">

            {{
              summary.grandTotal
            }}

          </td>

        </tr>

      </tbody>

    </table>

  </div>

</div>